import { ApiBase } from 'api/api'
import { makePatchRequest } from 'api/fetchCalls'
import type { ReminderProps } from 'types/reminders'

export const updateReminderById = (
  data: ReminderProps
): Promise<ReminderProps> => {
  return makePatchRequest(`${ApiBase}/reminders/${data.id}/`, {
    body: JSON.stringify(data),
    params: { global: false },
  })
}
